// Helper function to format duration (accepts hours from backend)
export const formatDuration = (hours) => {
  if (!hours) return '';
  const wholeHours = Math.floor(hours);
  const remainingMinutes = Math.round((hours - wholeHours) * 60);
  
  // If it's a whole number of hours
  if (remainingMinutes === 0) {
    return `${wholeHours} ${wholeHours === 1 ? 'hour' : 'hours'}`;
  }
  
  // If there are fractional hours, show hours and minutes
  if (wholeHours === 0) {
    return `${remainingMinutes} ${remainingMinutes === 1 ? 'minute' : 'minutes'}`;
  }
  
  return `${wholeHours} ${wholeHours === 1 ? 'hour' : 'hours'} ${remainingMinutes} min`;
};
